import React, { useEffect, useReducer, useState, useMemo } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { MdManageAccounts } from "react-icons/md";
import { MdOutlineSubscriptions } from "react-icons/md";
import { MdSubscriptions } from "react-icons/md";
import { SignedIn, SignedOut, useAuth, UserButton, useUser } from '@clerk/clerk-react';
import Cookie from '../../../utils/Cookie';
import { getSocket, SocketConnect } from '../../../socket';
import { hardSignOut } from '../../../services/authSession';
import toast from 'react-hot-toast';
import Reducer from '../../../services/Reducer';
import { CHAT_URL, USER_LIST } from '../../../utils/apiUrl';
import { CallWithAuth } from '../../../actions/apiAction';
import { Avatar } from '@mui/material';
import { utcToLocal } from '../../../utils/helpers';
import { useSelector } from 'react-redux';
import { motion } from "framer-motion";
import FeedbackForm from '../../../components/Feedback/FeedbackFrom';

const initState = {
    userList: '',
    loading: true,
    creatorsList: '',
    creatorsLoading: true,
    creatingChat: false,
};
const CreatorList = () => {
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const username = query.get("username");
    const navigator = useNavigate();
    const [sidePanel, setSidePanel] = useState(false);
    const { user } = useUser();
    const { isInitialized } = useSelector(state => state.socketSlice);
    const { signOut } = useAuth();
    const [state, dispatch] = useReducer(Reducer, initState);
    const [showFeedbackForm, setShowFeedbackForm] = useState(false);
    const getUserList = async () => {
        dispatch({ type: "SETDATA", payload: { name: "loading", value: true } });

        let responce = await CallWithAuth("GET", CHAT_URL);
        if (responce.data) {
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "userList", value: responce?.data } });
        } else {
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "userList", value: [] } });

        }
        dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
    };

    const getCreatorsList = async () => {
        dispatch({ type: "SETDATA", payload: { name: "creatorsLoading", value: true } });

        let responce = await CallWithAuth("GET", USER_LIST);
        if (responce.data) {
            dispatch({ type: "SETDATA", payload: { name: "creatorsLoading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "creatorsList", value: responce?.data } });
        } else {
            dispatch({ type: "SETDATA", payload: { name: "creatorsLoading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "creatorsList", value: [] } });
        }
        dispatch({ type: "SETDATA", payload: { name: "creatorsLoading", value: false } });
    };

    const handleChatClick = (item) => {
        Cookie.setCookie('activeChatId', item?._id, 1);
        navigator('/user/chat?id=' + item?.creator_id, { state: { user: item } })
    };

    const handleCreatorClick = async (creator) => {
        if (state.creatingChat) return; // Prevent multiple clicks

        try {
            dispatch({ type: "SETDATA", payload: { name: "creatingChat", value: true } });

            // Create chat with the creator
            const response = await CallWithAuth("POST", CHAT_URL, {
                creator_id: creator.user_id
            });

            if (response.data) {
                // Set the active chat ID
                Cookie.setCookie('activeChatId', response.data._id, 1);

                // Navigate to chat with the response data
                navigator('/user/chat?id=' + creator?.user_id, {
                    state: { user: response.data }
                });
            } else {
                toast.error("Failed to create chat");
                dispatch({ type: "SETDATA", payload: { name: "creatingChat", value: false } });
            }
        } catch (error) {
            console.error("Error creating chat:", error);
            toast.error(error?.response?.data?.detail || "Failed to create chat. Please try again.");
            dispatch({ type: "SETDATA", payload: { name: "creatingChat", value: false } });
        }
    };

    // Filter out creators that are already in user's chats
    const filteredCreators = useMemo(() => {
        // Early return guarantees state.creatorsList and state.userList exist below
        if (!state.creatorsList || !state.userList) return state.creatorsList || [];
        const existingChatCreatorIds = new Set(
            state.userList.map(chat => chat.creator_id)
        );
        return state.creatorsList.filter(
            creator => !existingChatCreatorIds.has(creator.user_id)
        );
    }, [state.creatorsList, state.userList]);

    const checkUserName = async () => {
        let responce = await CallWithAuth("GET", CHAT_URL + `?creator_username=${username}`);
        if (responce.data) {
            Cookie.setCookie('activeChatId', responce?.data._id, 1);
            navigator('/user/chat?id=' + responce.data?.creator_id, {
                state: {
                    user: responce.data
                }
            })
        } else {
            toast.error('Creator Not found')
            navigator('/user/creator-list')
        }
    }
    useEffect(() => {
        getUserList();
        getCreatorsList();
        const socket = getSocket();
        if (!socket) return;
    }, []);

    useEffect(() => {
        if (username) {
            username && checkUserName()
        }
    }, [username])
    return (
        <>
            <Helmet>
                <title>Home | TLK</title>
            </Helmet>
            <SignedIn>
                <div className="main-body  dark-theme-1">
                    {isInitialized === 'connecting' && (
                        <div className="w-full absolute top-0 left-0 z-50">

                            <div className="relative w-full h-8 bg-gray-700/80 backdrop-blur-sm overflow-hidden flex items-center justify-center">

                                {/* Animated loader */}
                                <motion.div
                                    className="absolute top-0 h-full w-1/3 bg-gradient-to-r from-[#AF0056] via-pink-500 to-[#FF4D9D] shadow-[0_0_12px_#AF0056]"
                                    initial={{ x: "-100%" }}
                                    animate={{ x: "300%" }}
                                    transition={{
                                        repeat: Infinity,
                                        duration: 1.2,
                                        ease: "linear"
                                    }}
                                />

                                {/* Centered text */}
                                <span className="relative z-10 text-xs text-white font-medium">
                                    Connecting, please wait...
                                </span>

                            </div>

                        </div>
                    )}
                    {
                        username && <div className="creating-chat-overlay">
                            <div className="loading-spinner">Loading chat with {username}...</div>
                        </div>
                    }
                    <div className="main-header-s1">
                        <h1 className="app-title">TLK</h1>
                        <div className="right-div">
                            {/* <div className="beta-branding"><img src="/images/beta-branding.svg" alt="" /></div> */}
                            <button className={sidePanel ? 'menu-toggle active' : 'menu-toggle'} onClick={() => setSidePanel(!sidePanel)}><div></div></button>
                        </div>
                    </div>
                    {/* <div className={sidePanel ? 'sidePanel show' : 'sidePanel'}>
                        <div className="sidePanel-header">
                            <h5>Menu</h5>
                            <button className={sidePanel ? 'menu-toggle active' : 'menu-toggle'} onClick={() => setSidePanel(!sidePanel)}><div></div></button>
                        </div>
                        <div className="sidePanel-body">
                            <div className="user-information-card">
                                <div className="top-info">
                                    <figure>
                                        <div className="image-container">
                                            <UserButton />
                                        </div>
                                    </figure>
                                    <h2>Welcome, {user.firstName}</h2>
                                    <h4>Email : {user.emailAddresses[0].emailAddress}</h4>
                                </div>
                            </div>
                            <div className="menu-lists">
                                <button className="menu-btn"
                                    onClick={() => { navigator('/user/my-profile') }}
                                >
                                    <span className="icon"><MdManageAccounts /></span>
                                    <span className="text">my account</span>
                                </button>
                                <button className="menu-btn" onClick={() => { navigator('/user/subscription-plans') }}>
                                    <span className="icon"><MdSubscriptions /></span>
                                    <span className="text">my subscription</span>
                                </button>
                            </div>
                        </div>
                        <div className="sidePanel-footer">
                            <div className="menu-lists">
                                <button className="menu-btn transparent-dark-btn" onClick={() => {
                                    signOut({ redirectUrl: '/' });
                                    Cookie.deleteCookie('userType');
                                    SocketDisconnect();
                                }}>
                                    <span className="icon"></span>
                                    <span className="text" >Logout</span>
                                </button>
                            </div>
                        </div>
                    </div> */}
                    <div className="body-content">
                        {(state.loading || state.creatorsLoading) ? (
                            <div className="flex justify-center items-center py-20 flex-auto">
                                <div className="loaderBox" style={{ position: 'unset', margin: 0, padding: 0, height: 'unset', width: 'unset' }}>
                                    <div className="relative flex items-center justify-center">

                                        {/* Outer glow ring */}
                                        <div className="absolute w-16 h-16 rounded-full bg-[#AF0056]/20 blur-xl animate-pulse"></div>

                                        {/* Spinner */}
                                        <div className="w-10 h-10 rounded-full border-4 border-transparent border-t-[#AF0056] border-r-pink-400 animate-spin"></div>

                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="dashboard-section">
                                {state.userList?.length > 0 ? (
                                    <div className="information-card-s1">
                                        <div className="body-sub-header-filter-s1 section-header">
                                            <h3>My Chats</h3>
                                        </div>
                                        <div className="wp-user-lists">
                                            {state.userList && state.userList?.map((item, index) => {
                                                return (
                                                    <div className="wp-user-list-item"
                                                        onClick={() => { handleChatClick(item); }}
                                                        key={index}
                                                    >
                                                        <div
                                                            className="user-container"
                                                        >
                                                            <Avatar alt="Remy Sharp" src={item?.profile_picture_url}>{item?.first_name?.charAt(0)}</Avatar>
                                                        </div>
                                                        <div className="text-container">
                                                            <div className="title-with-date">
                                                                <h4>{item?.first_name} {item?.last_name}</h4>
                                                                <div className="date">{item?.last_message_at ? utcToLocal(item?.last_message_at) : ''}</div>
                                                            </div>
                                                            <div className="des-with-counter">
                                                                <p>{item?.last_message || "No messages yet"}</p>
                                                                {/* <div className="counter">1</div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                ) : <div className="flex flex-col items-center justify-center text-center py-12 px-6 min-h-[340px]">



                                    <div className="relative w-28 h-28 mb-7">
                                        {[0, 0.9, 1.8].map((delay, i) => (
                                            <div key={i} className="absolute inset-0 rounded-full border border-white/10 animate-ping"
                                                style={{ animationDelay: `${delay}s`, animationDuration: '2.8s' }} />
                                        ))}
                                        <div className="absolute inset-0 flex items-center justify-center"
                                            style={{ animation: 'float 3.4s ease-in-out infinite' }}>
                                            <div className="w-[72px] h-[72px] rounded-full bg-white/5 border border-white/10 flex items-center justify-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} viewBox="0 0 24 24"
                                                    fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"
                                                    className="text-muted-foreground">
                                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>



                                    <h3 className="text-lg font-semibold text-foreground mb-2">No active conversations yet</h3>
                                    <p className="text-sm text-muted-foreground leading-relaxed max-w-[260px] mb-7">
                                        Visit your favourite creator's magic link and start TLKing now!
                                    </p>
                                </div>}

                                {/* <div className="information-card-s1 explore-section">
                                    <div className="body-sub-header-filter-s1 section-header">
                                        <h3>Explore</h3>
                                    </div>
                                    <div className={`explore-creators-grid ${state.creatingChat ? 'disabled' : ''}`}>
                                        {
                                            filteredCreators?.length > 0 && (
                                                filteredCreators.map((creator, index) => {
                                                    return (
                                                        <div
                                                            className="explore-creator-card"
                                                            onClick={() => { handleCreatorClick(creator); }}
                                                            key={index}
                                                        >
                                                            <div className="creator-avatar">
                                                                <Avatar
                                                                    alt={creator?.first_name}
                                                                    src={creator?.profile_picture_url}
                                                                    sx={{ width: 120, height: 120, fontSize: 48 }}
                                                                >
                                                                    {creator?.first_name?.charAt(0)}
                                                                </Avatar>
                                                            </div>
                                                            <div className="creator-info">
                                                                <h4>{creator?.first_name} {creator?.last_name}</h4>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )
                                        }
                                        {filteredCreators?.length === 0 && (
                                            <div className="no-creators-message">
                                                <p>No new creators to explore</p>
                                            </div>)}
                                        {state.creatingChat && (
                                            <div className="creating-chat-overlay">
                                                <div className="loading-spinner">Creating chat...</div>
                                            </div>
                                        )}
                                    </div>
                                </div> */}
                            </div>
                        )}
                    </div>
                </div>
                {/* Got feedback? floating button */}
                <div className="fixed bottom-6 left-0 right-0 flex justify-center z-30 pointer-events-none">
                    <button
                        className="pointer-events-auto px-6 py-3 rounded-full text-white font-medium text-sm shadow-lg shadow-[#AF0056]/30 transition-transform active:scale-95"
                        style={{ background: 'linear-gradient(135deg, #AF0056, #FF4DA6)' }}
                        onClick={() => setShowFeedbackForm(true)}
                    >
                        Got feedback?
                    </button>
                </div>
                {/* Feedback modal */}
                {showFeedbackForm && (
                    <>
                        <motion.div
                            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setShowFeedbackForm(false)}
                        />
                        <motion.div
                            className="fixed inset-0 z-50 flex items-center justify-center px-4"
                            initial={{ opacity: 0, y: 40 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 40 }}
                            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                        >
                            <div className="w-full max-w-sm bg-card rounded-2xl shadow-2xl p-4 relative max-h-[100vh] overflow-y-auto"
                                onClick={e => e.stopPropagation()}
                            >
                                <FeedbackForm onClose={() => setShowFeedbackForm(false)} />
                            </div>
                        </motion.div>
                    </>
                )}
                {/* start: side menu */}
                {sidePanel &&
                    <div
                        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
                        onClick={() => setSidePanel(false)}
                    />
                }
                <div
                    className={`fixed left-0 top-0 bottom-0 w-80 max-w-[85vw] bg-card shadow-2xl z-50 overflow-y-auto 
                    transition ${sidePanel ? 'translate-x-none' : '-translate-x-full'}`}
                >
                    <div className="p-6">
                        <div className="flex items-center justify-between mb-4">
                            <h2 className="text-2xl font-bold text-foreground">Menu</h2>
                            <button className="text-muted-foreground hover:text-foreground transition-colors" onClick={() => setSidePanel(false)}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-x w-6 h-6"
                                >
                                    <path d="M18 6 6 18" />
                                    <path d="m6 6 12 12" />
                                </svg>
                            </button>
                        </div>
                        <nav className="space-y-2">
                            <div className="user-information-card">
                                <div className="top-info">
                                    <figure>
                                        <div className="image-container">
                                            <UserButton />
                                        </div>
                                    </figure>
                                    <h2>Welcome, {user?.firstName}</h2>
                                    <h4>Email : {user?.emailAddresses[0]?.emailAddress}</h4>
                                </div>
                            </div>
                            <button className="w-full flex items-center gap-3 p-3 rounded-2xl hover:bg-[#f4e1e8] transition-colors text-left"
                                onClick={() => navigator('/user/settings')}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#af0056"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-settings w-5 h-5 text-primary"
                                >
                                    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                                    <circle cx={12} cy={12} r={3} />
                                </svg>
                                <span className="text-foreground font-medium">Settings</span>
                            </button>
                            <button className="w-full flex items-center gap-3 p-3 rounded-2xl hover:bg-[#f4e1e8] transition-colors text-left"
                                onClick={() => navigator('/user/terms')}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#af0056"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-file-text w-5 h-5 text-primary"
                                >
                                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                                    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                                    <path d="M10 9H8" />
                                    <path d="M16 13H8" />
                                    <path d="M16 17H8" />
                                </svg>
                                <span className="text-foreground font-medium">Terms of Service</span>
                            </button>
                            <button className="w-full flex items-center gap-3 p-3 rounded-2xl hover:bg-[#f4e1e8] transition-colors text-left"
                                onClick={() => navigator('/user/privacy')}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#af0056"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-lock w-5 h-5 text-primary"
                                >
                                    <rect width={18} height={11} x={3} y={11} rx={2} ry={2} />
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                </svg>
                                <span className="text-foreground font-medium">Privacy Policy</span>
                            </button>
                            <div className="pt-3 border-t border-border mt-3">
                                <button className="w-full flex items-center gap-3 p-3 rounded-2xl hover:bg-[#e236361a] transition-colors text-left"
                                    onClick={() => hardSignOut(signOut)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#db2424"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-log-out w-5 h-5 text-destructive"
                                    >
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                        <polyline points="16 17 21 12 16 7" />
                                        <line x1={21} x2={9} y1={12} y2={12} />
                                    </svg>
                                    <span className="text-destructive font-medium">Log Out</span>
                                </button>
                            </div>
                        </nav>
                    </div>
                </div>
                {/* end: side menu */}
            </SignedIn>
        </>
    );
}

export default CreatorList;
